<template>
  <div>
    <filter-event
      :range="range"
      v-model="event"/>
    <div class="mt-3">{{header}}</div>
    <filter-range
      v-model="money"
    ></filter-range>

  </div>
</template>

<script>
  import { omitBy, isEmpty, isEqual } from 'lodash'

  export default {
    props: {
      range: {type: Object},
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
      header: {type: String},
    },
    data () {
      return {
        event: {
          number: this.value.number || {},
          date: this.value.date || {}
        },
        money: this.value.moneyRange || {},
      }
    },
    computed: {
      preparedInput () {
        return omitBy({
          number: this.event.number,
          date: this.event.date,
          moneyRange: this.money,
        }, isEmpty)
      },
    },
    watch: {
      value (input) {
        this.event = {
          number: input.number || {},
          date: input.date || {}
        }
        this.money = input.moneyRange || {}
      },
      preparedInput: {
        handler (newVal, oldVal) {
          if (!isEqual(newVal, oldVal)) {
            this.$emit('input', this.preparedInput)
          }
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-event-depositing-money.vue